import React from 'react';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import { connect } from 'react-redux';
import FormFlatContainer from '../forms/Elements/FormFlatContainer.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import KeyOutlinedIconCustom from '../CustomIcons/KeyOutlinedIconCustom.jsx';


@connect(state => ({
  mks: state.mks,
}))
class MksKeyDetailsView extends React.Component {

  render() {
    const { keyData, onRequestKeyDuplication } = this.props;
    const associatedCylinders = keyData.associatedCylinders || [];
    return (
      <div style={{ paddingBottom: 100, padding: 0 }}>
        <FormFlatContainer
          title="keyDetails"
          icon={<KeyOutlinedIconCustom style={{ width: 22, color: '#3f3f3f' }} />}
          containerStyle={{ marginRight: 15, marginTop: 0 }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  {'Id'}
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{keyData.id || '---'}</h4>
              </div>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="externalId" />
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{keyData.externalId || '---'}</h4>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="keyFunction" />
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{keyData.keyFunction || '---'}</h4>
              </div>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="designation" />
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{keyData.designation || '---'}</h4>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="quantity" />
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{keyData.quantity || '---'}</h4>
              </div>
              <div style={{ flex: 1 }} />
            </div>
            <MDButton
              title={<Entity entity="requestKeyDuplication" />}
              onClick={() => onRequestKeyDuplication && onRequestKeyDuplication(keyData)}
              containerStyle={{ width: '90%', margin: 'auto', marginTop: 5 }}
          />
          </div>
        </FormFlatContainer>
        <FormFlatContainer
          title="associatedCylinders"
          subtitle="associatedCylindersSubtitle"
          containerStyle={{ marginRight: 15, marginTop: 20 }}
        >
          {!_.isEmpty(associatedCylinders) ? (
            <Table size="small">
              <TableHead>
                <TableRow style={{ backgroundColor: '#f0f0f0' }}>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="externalId" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="doorName" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="marking" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="type" /></h5></TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ maxHeight: 200, overflowY: 'auto', backgroundColor: 'white' }}>
                {_.map(associatedCylinders, (cylinder) => (
                  <TableRow key={cylinder.cylinderId || cylinder.id}>
                    <TableCell><h5 style={{ margin: 0 }}>{cylinder.cylinderExternalId || cylinder.externalId || '---'}</h5></TableCell>
                    <TableCell><h5 style={{ margin: 0 }}>{cylinder.cylinderDoorName || cylinder.doorName || '---'}</h5></TableCell>
                    <TableCell><h5 style={{ margin: 0 }}>{cylinder.cylinderMarking || cylinder.marking || '---'}</h5></TableCell>
                    <TableCell><h5 style={{ margin: 0 }}>{cylinder.cylinderType || cylinder.type || '---'}</h5></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <div style={{ textAlign: 'center', padding: 20 }}>
              <h5 style={{ color: '#888' }}><Entity entity="noAssociatedCylinders" /></h5>
            </div>
          )}
        </FormFlatContainer>
      </div>
    );
  }
}

export default MksKeyDetailsView;

